import { j as e } from "./jsx-runtime-e6RZPHeG.js";
import { memo as m } from "react";
const i = ({
  title: l,
  titleId: o,
  ...c
}) => /* @__PURE__ */ e.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": o,
    ...c,
    children: [
      l ? /* @__PURE__ */ e.jsx("title", { id: o, children: l }) : null,
      /* @__PURE__ */ e.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M152.971 544.215v147.456h134.272c24 0 42.667-3.243 56.021-9.749 24.235-11.989 36.352-35.029 36.352-69.035 0-28.779-11.776-48.533-35.221-59.307-13.141-5.995-31.552-9.109-55.296-9.365zm0-213.482v121.92h134.421c24.021 0 43.52-4.544 58.496-13.696 14.976-9.109 22.464-25.323 22.464-48.576 0-25.771-9.899-42.773-29.717-51.029-17.088-5.76-38.869-8.619-65.323-8.619zM453.28 293.57c16.917 23.531 25.387 51.648 25.387 84.416 0 33.792-8.555 60.907-25.621 81.429-9.557 11.499-23.595 22.016-42.176 31.509 28.224 10.261 49.515 26.539 63.872 48.789 14.379 22.272 21.568 49.28 21.568 81.045 0 32.768-8.213 62.165-24.64 88.192-10.432 17.237-23.509 31.744-39.147 43.52-17.664 13.504-38.507 22.741-62.507 27.755s-50.048 7.509-78.144 7.509H42.656V234.667h267.285c67.456 1.003 115.221 20.629 143.339 58.901zm240.358 185.843c-15.104 15.595-24.619 36.693-28.501 63.296h184.235c-1.941-28.373-11.435-49.92-28.48-64.619-17.045-14.677-38.187-22.059-63.424-22.059-27.456 0-48.725 7.808-63.829 23.381zm-85.141-160.32H875.27v-57.024H608.497zm245.12 67.947c28.523 12.779 52.075 32.939 70.677 60.501 16.747 24.299 27.584 52.48 32.576 84.544 2.88 18.795 4.032 45.867 3.52 81.173H662.513c1.664 41.024 15.936 69.781 42.773 86.293 16.341 10.261 35.968 15.403 58.965 15.403 24.363 0 44.139-6.251 59.392-18.773 8.277-6.763 15.616-16.128 21.995-28.16h109.163c-2.88 24.277-16.085 48.917-39.637 73.941-36.629 39.765-87.915 59.648-153.856 59.648-54.421 0-102.464-16.747-144.064-50.304s-62.421-88.128-62.421-163.755c0-70.827 18.795-125.163 56.363-162.965 37.547-37.803 86.293-56.725 146.24-56.725 35.584 0 67.648 6.4 96.192 19.179z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), r = m(i);
export {
  r as default
};
